import {Person, PersonFilterOptions, PersonListItem, UpdatePerson} from "@/services/models/Person";
import {PagedData} from "@/services/models/shared/PagedData";
import {AxiosResponse} from "axios";
import FileProvider from "@/utilities/providers/FileProvider";
import {Role} from "@/services/models/Role";
import BimsHttpService from "@/services/BimsHttpService";
import { EmployeeUserType } from "./models/shared/EmployeeUserType";

class PersonService {
    /**
     *  @description Retrieves all people
     */
    getAllPeople(onlyShowTTI: boolean | undefined): Promise<PersonListItem[]> {
        const vm = this;
        return vm.getPeopleList({
            onlyShowActive: true,
            onlyShowTTI: onlyShowTTI ?? true,
            employeeUserType: null,
            pageSize: 1,
        } as PersonFilterOptions)
            .then((response) => {
                return vm.getPeopleList({
                    onlyShowActive: true,
                    onlyShowTTI: onlyShowTTI ?? true,
                    employeeUserType: null,
                    pageSize: response.totalCount,
                    page: 1
                } as PersonFilterOptions)
                    .then((responses) => {
                        return responses.data;
                    })
            })
    }

    /**
     * @description Returns a paged list of people.
     */
    getPeopleList(filter: PersonFilterOptions): Promise<PagedData<PersonListItem>> {
        return BimsHttpService.get(`/people`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<PersonListItem>>) => {
            return response.data as PagedData<PersonListItem>;
        });
    }

    /**
     * @description Returns the person with the specified id
     */
    getPerson(id: string): Promise<Person> {
        return BimsHttpService.get(`/people/${id}`).then((response: AxiosResponse<Person>) => {
            return response.data as Person;
        });
    }

    /**
     *  @description Updates the general information for an organization
     */
    updatePerson(person: UpdatePerson): Promise<any> {
        return BimsHttpService.put("/people/" + person.id,
            person
        )
    }

    /**
     * @description Downloads the CSV export for the base account listing
     */
    public getExcelExport(
        filter: PersonFilterOptions
    ): Promise<any> {
        return BimsHttpService.get(
            `people/export`, {
                params: filter
            }).then(response => {
            return FileProvider.ForceFileDownload(response)
        })
    }

    /**
     *  @description Retrieves all application roles
     */
    getAllRoles(): Promise<Role[]> {
        return BimsHttpService.get(`/roles`).then((response: AxiosResponse<Role[]>) => {
            return response.data as Role[];
        });
    }

    /**
     *  @description Retrieves all application roles for a person
     */
    getRolesForPerson(personId: string): Promise<Role[]> {
        return BimsHttpService.get(`people/${personId}/roles`).then((response: AxiosResponse<Role[]>) => {
            return response.data as Role[];
        });
    }

    /**
     *  @description Sets the application roles for th person
     */
    updateRolesForPerson(personId: string, roles: Role[]): Promise<any> {
        return BimsHttpService.put(`people/${personId}/roles`, roles);
    }
}

export default new PersonService()
